const Socials = () => {
	return (
		<>
			<a href="https://www.facebook.com/gajewwwski.net" className="socialLink">
				<span className="fab fa-facebook-f"></span>
			</a>
			<a
				href="https://www.linkedin.com/in/kg-kamil-gajewski"
				className="socialLink"
			>
				<span className="fab fa-linkedin-in"></span>
			</a>
			<a href="https://github.com/kwaq102" className="socialLink">
				<span className="fab fa-github"></span>
			</a>
		</>
	);
};

export default Socials;
